module.exports = __webpack_public_path__ + "img/stage3_large.1465f3ea.png";